// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Divider, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import CustomButton from '../../../../elements/CustomButton/CustomButton';

import type {StoreBenefit} from '../../api';
type Props = {
  name: string,
  points: string,
  label: StoreBenefit,
  handleRedeem: (redeem: StoreBenefit) => void,
  disabled: boolean,
};

const useStyles = makeStyles(theme => ({
  containerCard: {
    backgroundColor: '#F4F4F6',
    padding: theme.spacing(2),
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  name: {
    textTransform: 'uppercase',
    fontWeight: '500',
    color: '#717190',
    textAlign: 'center',
  },
  points: {
    color: '#3A3A49',
    letterSpacing: '0.02em',
    fontWeight: 600,
    fontSize: '24px',
  },
  wrapperPoint: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  textPoints: {
    color: '#3A3A49',
    fontWeight: 500,
    fontSize: '14px',
  },
  divider: {
    backgroundColor: '#E8E8ED',
    width: '100%',
    margin: theme.spacing(1, 0),
  },
  btnRedeem: {
    margin: theme.spacing(2, 0),
  },
}));

export default function CardRedeemDescription(props: Props) {
  const {name, points, label, handleRedeem, disabled} = props;
  const classes = useStyles();

  const onRedeem = () => {
    handleRedeem(label);
  };

  return (
    <div className={classes.containerCard}>
      <Typography className={classes.name}>{name}</Typography>
      <Divider className={classes.divider} />
      <div className={classes.wrapperPoint}>
        <Typography className={classes.points}>{points}</Typography>
        <Typography className={classes.textPoints}>
          punto{Number(points) > 1 ? 's' : ''}
        </Typography>
        <CustomButton
          variant="contained"
          className={classes.btnRedeem}
          onClick={onRedeem}
          disabled={disabled}
        >
          Canjear
        </CustomButton>
      </div>
    </div>
  );
}

CardRedeemDescription.propTypes = {
  name: PropTypes.string.isRequired,
  points: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  handleRedeem: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};
